import PropTypes from 'prop-types'
import React from 'react'

import BuyBigModal from '../../buy/dumb/BuyBigModal'

const DocumentiHelperModal = ({
  display,
  onClose,
  iframeSrc,
  modalTitle,
  variant,
}) => (
  <BuyBigModal
    display={display}
    extraStyle={{
      padding: 0,
    }}
    h4={modalTitle}
    hasPadding={false}
    onClose={onClose}
    variant={variant}
  >
    <iframe
      src={iframeSrc}
      style={{
        border: 'none',
        width: '100%',
        height: '100%',
      }}
    />
  </BuyBigModal>
)

DocumentiHelperModal.defaultProps = {
  iframeSrc: `${window.location.origin}/supporto-documenti?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`,
  onClose: () => {},
  display: false,
  modalTitle: 'Come effettuare la foto ai documenti',
  variant: 'simplemodal__popup--full-height simplemodal__popup--mid-width',
}

DocumentiHelperModal.propTypes = {
  display: PropTypes.bool,
  onClose: PropTypes.func,
  modalTitle: PropTypes.string,
  iframeSrc: PropTypes.string,
  variant: PropTypes.string,
}

export default DocumentiHelperModal
